// removed by extract-text-webpack-plugin
module.exports = {"total":"HistoryFooter__total___WIq-4"};